import { Component, OnInit, Injectable } from '@angular/core';
import { Config } from "./config";
import { Http, Response } from "@angular/http";
import "rxjs/add/operator/map";
import { EditorService } from '../../../editor.service';
@Component({
  selector: 'app-symbol',
  templateUrl: './symbol.component.html',
  styleUrls: ['./symbol.component.css']
})
export class SymbolComponent implements OnInit {

  constructor(private http: Http, private editorService: EditorService) { }
  mathjaxData;
  mSymbol;
  ngOnInit() {
    let error = false;
    return new Promise((resolve, reject) => {
      this.http
        .get(`${Config.IS_MOBILE_NATIVE() ? "/" : ""}assets/mathjax/MathSymbols.json`)
        .subscribe(res => {
          this.mathjaxData = res.json();
          if (error) {
            reject("error");
          } else {
            resolve(this.mathjaxData);
          }
        });
    });
  }


  addMathjaxSymbol(symbol, ind) {
    this.mSymbol = symbol;
    this.mSymbol.id = ind;
    let layer = this.editorService.getIframeReference();
    if (ind < 9) {
      layer.onMathSymbolClick(this.mSymbol);
    } else {
      layer.onTextSymbolClick(this.mSymbol);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/symbol/symbol.component.ts